import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import SidebarContainer from '../SidebarContainer';
import dealersActions from '../../redux/dealers/actions';
import loginsActions from '../../redux/logins/actions';
import ContentPage from '../ContentPage';
import ErrorMessage from '../../components/ErrorMessage';
import './Login.scss';

import LoginEditor from '../../components/LoginEditor';
import DealerNav from '../../components/DealerNav';
import LoginVerificationMessage from '../../components/LoginVerificationMessage';

class Login extends Component {
  componentDidMount() {
    const { loginId, dealerId } = this.props.match.params;
    if (loginId) {
      this.props.actions.loginRequest(loginId);
    } else {
      this.props.actions.resetLogin(dealerId);
    }
  }

  onCreate = params => {
    this.props.actions.createLoginRequest(params);
  };

  onSave = login => {
    this.props.actions.updateLoginRequest(login);
  };

  verifyLoginRequest = data => {
    const { logins, actions } = this.props;
    // only try to verify if there isn't an existing verification request
    if (!logins.verificationStatus.fetching) {
      actions.verifyLoginRequest(data);
    }
  };

  render() {
    const { logins, dealer, actions } = this.props;
    const { login, error, fetching, verificationStatus } = logins;
    const isNewLogin = !login.id;
    const editorOnSave = isNewLogin ? this.onCreate : this.onSave;

    return (
      <SidebarContainer title={dealer.name} logo={dealer.logo}>
        <div className="logins-table">
          <DealerNav />
          {error && <ErrorMessage error={error} />}
          <LoginVerificationMessage verificationStatus={verificationStatus} />
          <LoginEditor
            dealerId={dealer.id}
            login={login}
            fetching={fetching}
            isNewLogin={isNewLogin}
            onSave={editorOnSave}
            verifyLogin={this.verifyLoginRequest}
            resetLoginVerification={actions.resetLoginVerification}
            crmType={dealer.crmType}
          />
        </div>
      </SidebarContainer>
    );
  }
}

Login.propTypes = {
  actions: PropTypes.object,
  logins: PropTypes.object,
  dealer: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = ({ logins, dealers }) => ({
  logins,
  dealer: dealers.dealer,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    { ...dealersActions, ...loginsActions },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentPage(Login));
